export default __webpack_public_path__ + "static/img/btn-retur-blue.e9fc0859.svg";